import { Link as LinkMui } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledLink = styled(LinkMui, {
  shouldForwardProp: (prop) => prop !== 'color' && prop !== 'textDecoration',
})(({ color, textDecoration }) => ({
  color,
  textDecoration,
}));
